import { gql } from '@lcs/shared/api';

export const SaveAllowedIpMutation = gql`
   mutation saveAllowedIpAddress($allowedIpAddress: AllowedIpAddressInput!) {
      saveAllowedIpAddress(allowedIpAddress: $allowedIpAddress) {
         allowedIpAddressId
         ipAddress
         accountId
         qManageTicketId
         originatingType
         status
         requestedByUserId
         createDate
         updateDate

         account {
            accountId
            name
         }

         requestedByUser {
            userId
            name
         }
      }
   }
`;
